import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { BillingTab } from './BillingTab';
import { OutpassesTab } from './OutpassesTab';
import { ResidentsTab } from './ResidentsTab';
import { RoomsTab } from './RoomsTab';
import { VisitorsTab } from './VisitorsTab';

type Tab = 'rooms' | 'residents' | 'outpasses' | 'visitors' | 'billing';

export function HostelPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('rooms');
  const tabs: Tab[] = [];
  if (schoolId && can('hostel.view', schoolId))
    tabs.push('rooms', 'residents', 'outpasses', 'visitors', 'billing');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('ho.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('ho.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`ho.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'rooms' && <RoomsTab schoolId={schoolId} />}
            {active === 'residents' && <ResidentsTab schoolId={schoolId} />}
            {active === 'outpasses' && <OutpassesTab schoolId={schoolId} />}
            {active === 'visitors' && <VisitorsTab schoolId={schoolId} />}
            {active === 'billing' && <BillingTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
